module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"16\" height=\"10\"><g fill=\"none\" fill-rule=\"evenodd\" stroke=\"#A2B0D5\"><ellipse cx=\"8\" cy=\"5\" rx=\"7.5\" ry=\"4.5\"/><circle cx=\"8\" cy=\"5\" r=\"2.5\"/></g></svg>"


//////////////////
// WEBPACK FOOTER
// ./public/img/eye.svg
// module id = Miz0
// module chunks = 5